import firebase from "firebase";
import { FirestoreHelper } from "../../helpers/firestoreHelper";
import { FirestoreUserModel } from "../../models/auth";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { upgradeAnonymousUser } from "../../helpers/apiHelper";

export const serializeFirebaseUserSnap = (
  userSnap: firebase.firestore.DocumentSnapshot
): FirestoreUserModel => {
  const data = userSnap.data() ?? {};
  return serializeFirebaseUser(data);
};

export const serializeFirebaseUser = (user: firebase.firestore.DocumentData): FirestoreUserModel => ({
  email: user.email ?? null,
  nickname: user.nickname ?? "",
  photoURL: user.photoURL ?? null,
  current_external_active_dine_in_table_sitting: user.current_external_active_dine_in_table_sitting?.path ?? null,
});

export const getUserProfile = async (user: firebase.User) => {
  if (!user) return serializeFirebaseUser({});
  const firestoreUser = await FirestoreHelper.userProfile(user.uid);
  return serializeFirebaseUser(firestoreUser?.data ?? {});
};

export const updateUserLanguage = async (
  uid: string,
) => {
  const lang = LocalizerHelper.getLanguage()
  return await FirestoreHelper.setLanguageToUser(uid, lang);
};

export const updateUserNickname = async (
  uid:string,
  nickname: string,
) => {
  return await FirestoreHelper.setUserNickname(uid, nickname);
};

export const upgradeAnonymous = async () => {
  return await upgradeAnonymousUser();
};